export default "__VITE_ASSET__ArzP1dsb__"